import React, { useEffect, useState } from 'react';
import '../../releaseproj/team.css';
import { withRouter } from 'react-router-dom';
import {
  deleteIpsUserFromTeam,
  getOtherRoles,
  getSelectedUser,
  getUser,
  getUserRoles,
  getNonCheckListUser,
  getTeamDetails,
  updateIpsTeamMemberDetails,
  addOrEditIpsTeamMember,
} from '../../../api';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { confirmAlert } from 'react-confirm-alert';
import { Col, Row } from 'react-flexbox-grid';
import { Input, List, Tooltip, Table, Empty } from 'antd';
import '../../../components/SearchBar/SearchBar.css';
import NumberFormat from 'react-number-format';
import Alert from '../../../components/Alert';
import EmailImage from '../Team/email.png';
import {  SearchOutlined } from '@ant-design/icons';
import EditTeamMemberDialog from './EditTeamMemberDialog';
import { Dropdown, DropdownButton } from 'react-bootstrap';

import ReactTooltip from 'react-tooltip';
import { projectStatusCodeMap } from 'components/ProjectStatusCodeMap';
import {isFMPCreatorOrAdministrator, isIPSDataCreatorOrAdministrator} from 'utils/UserInfo';
import { SearchAndDropdownComponent, commonFilter, commonSorter, composeFilters, getStationRoleName } from 'utils/AntdTableFunctions';

const sectionStyle = {
  width: '20px',
  height: '20px',
};

const tooltext = (
  <span>
    Please enter minimum 3 characters. 5 characters for quick search results.
  </span>
);
const taskRoles = [33, 10, 6, 2, 9, 4, 5];
const approverRoles = [30, 1, 29, 25, 26, 27, 2];

function IPSTeam(props) {
  const UNSELECTED_ROLE = '0';
  const T_NAME = 'Name';
  const PHONE_REGEX = /[^0-9 \-]/g;
  const { project } = props;
  
  const [teams, setTeams] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [text, setText] = useState('');
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState({
    userId: '',
    firstName: '',
    lastName: '',
    displayName: '',
    cellNumber: '',
    company: '',
    email: '',
    role: '',
    phoneNumber: '',
  });
  const [otherRoles, setOtherRoles] = useState([]);
  const [roles, setRoles] = useState([]);

  const [selectedRole, setSelectedRole] = useState('0');
  const [selectedOtherRole, setSelectedOtherRole] = useState('0');

  const [validationErrors, setValidationErrors] = useState({
    role: null,
    duplicateUser: null,
    name: null,
  });
  const [refresh, setRefresh] = useState(true);
  const filterValue =(
    project.fmpProjectDetails &&
    project.fmpProjectDetails.length > 0
  ) ? project.fmpProjectDetails[0].fmpId : null;

  let projectInfo = {
    bpid: project.bpid,
    workOrder: project.workOrder,
    stationName: project.stationName,
    fmpId: filterValue
  };
  /** adding team members to users **/
  useEffect(() => {
    async function getData() {
      
      const teams =  getTeamDetails(projectInfo);
      
      // let userIds = teams.map(team => userIds.push(team.userId));

      //User roles for team members
      const rolesResponse =  getUserRoles();
     
      const otherRoles =  getOtherRoles();

      const result = await Promise.allSettled([teams,rolesResponse,otherRoles])
      
      setTeams(result[0].value);
      setRoles(result[1].value.data);
      setOtherRoles(result[2].value);


      setRefresh(false);
    }

    if (refresh) getData();
  }, [refresh]);

  //Input key for dropdown in project team
  const handleChange = (e) => {
    const selection = e.currentTarget.value;
    setSelectedRole(selection);
    validationError('role', selection === UNSELECTED_ROLE ? 1 : 0);
  };

  const handleRoleChange = (e) => {
    const selection = e.currentTarget.value;
    setSelectedRole(selection);
    validationError('role', selection === UNSELECTED_ROLE ? 1 : 0);
  };

  const handleOtherRoleChange = (e) => {
    let selection = e.currentTarget.value;
    setSelectedOtherRole(selection);
  };

  //suggestions for users for project
  async function onTextChanged() {
    const value = text;
    let suggestions = [];
    if (value.length > 2) {
      //TODO: better loading state while searching names
      suggestions = [{ firstName: 'Please', lastName: 'Wait...' }];
      setSuggestions(suggestions);
      suggestions = await getUser(value);

      if (!suggestions) suggestions = [];
      setSuggestions(suggestions);
      validationError('name', value === T_NAME ? 1 : 0);
    }
  }

  const updateText = (e) => {
    let text = e.target.value;
    if (!text || text === '') {
      setUser({
        userId: '',
        firstName: '',
        lastName: '',
        displayName: '',
        cellNumber: '',
        company: '',
        email: '',
        role: '',
        phoneNumber: '',
      });
      setSuggestions([]);
    }
    setText(text);
  };

  async function suggestionSelected(value) {
    let newFirstName;
    let newLastName;
    //handling undefined value case incase

    if (value.displayName) {
      // to divide display in order to overwrite first and last Name
      let displayNameArray = value.displayName.split(' ');
      newFirstName = displayNameArray[0];
      newLastName = displayNameArray.slice(1).join(' ');
    } else {
      newFirstName = value.firstName;
      newLastName = value.lastName;
    }

    let selectedUser = await getSelectedUser(value.userId);
    let updatedUser = { ...value };

    if (selectedUser.user && selectedUser.user.userId) {
      if (selectedUser.user.cellNumber) {
        updatedUser = {
          ...value,
          ...{ cellNumber: selectedUser.user.cellNumber },
        };
      }
      if (selectedUser.user.phoneNumber) {
        updatedUser = {
          ...updatedUser,
          ...{ phoneNumber: selectedUser.user.phoneNumber },
        };
      }
    }

    // upending first and lastName for using display name so we can display according to display name
    updatedUser = {
      ...updatedUser,
      firstName: newFirstName,
      lastName: newLastName,
    };

    setUser(updatedUser);
/* using updatedUser.firstName and updated.LastName instead of value.firstName and lastName because value still contain
original value
*/
    setText(updatedUser.firstName + ' ' + updatedUser.lastName);

    setSuggestions([]);
  }

  function renderSuggestions() {
    if (suggestions.length === 0) {
      return <div />;
    }
    return (
      <List className='list-style'>
        {suggestions.map((suggestion, index) => (
          <List.Item
            style={{ cursor: 'pointer' }}
            className='list-item'
            onClick={() => suggestionSelected(suggestion)}
            key= {index}
          >
            
            {suggestion.displayName ?
            <>
              { suggestion.displayName } {suggestion.userId}</>
            :<>{suggestion.firstName}{'   '}{suggestion.lastName}{' '}{suggestion.userId}</>}
          </List.Item>
        ))}
      </List>
    );
  }

  //validation for drop down selection
  function selectedValidRole() {
    if (selectedRole === UNSELECTED_ROLE) {
      validationError('role', 1);
      return false;
    }
    return true;
  }

  function validInputName() {
    if (suggestions.length === 0) {
      validationError('name', 1);
      return false;
    }
    return true;
  }

  const validDuplicateUser = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='react-confirm-alert-body'>
            <p>
              {user.firstName} {user.lastName}{" "}
              has already been added. To change or add additional user roles,
              you must EDIT the team member.
            </p>{' '}
            <br />
            <div className='btn start-2'>
              <button
                className='btn btn-primary start-5'
                onClick={() => {
                  onClose();
                }}
              >
                OK
              </button>
            </div>
          </div>
        );
      },
    });
  };

  const validCheckListUser = (
    projectInfo,
    userId,
    userRoles,
    otherRoleId,
    user,
    context
  ) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='react-confirm-alert-body'>
            <h2>Warning</h2>
            <p>
              {'This person does not have login access granted for the Checklist App and will not be able to Sign Tasks or Approve Exceptions, ' +
                'if needed. To grant login access, submit a MyAccess request.'}
            </p>
            <br />
            <div className='btn start-2'>
              <button
                className='btn btn-primary start-5'
                onClick={async () => {
                  await addOrEditIpsTeamMember(
                    projectInfo,
                    userId,
                    userRoles,
                    otherRoleId,
                    user
                  );
                  clearInputs();
                  setRefresh(true);
                  onClose();
                  context.setRefreshMemberNotifications(true);
                }}
              >
                OK
              </button>
            </div>
          </div>
        );
      },
    });
  };

  function validationError(type, value) {
    setValidationErrors((prevState) => {
      const nextState = { ...prevState };
      nextState[type] = value;
      return nextState;
    });
  }

  //adding user to team
  async function addUserToTeam() {
    const userId = user.userId;
    const roleId = selectedRole;
    let otherRoleId = null;
   
    if (!selectedValidRole() || userId === '') {
      return;
    }

    let duplicateUser = false;
    teams?.map((teamMember) => {
      if (teamMember.userId === user.userId) {
        duplicateUser = true;
        validDuplicateUser();
      }
    });

    if (
      !duplicateUser &&
      (roleId === '24' || roleId === 24) &&
      selectedOtherRole !== '0'
    ) {
      otherRoleId = selectedOtherRole;
    }
    if (!duplicateUser) {
      //check if the user is a non checklist user
      let userRoles = [
        {
          roleId: roleId,
          action: 'A',
        },
      ];
      if (
        taskRoles.includes(parseInt(roleId)) ||
        approverRoles.includes(parseInt(roleId))
      ) {
        //console.log('add User.....', user);
        let response = await getNonCheckListUser(user);

        if (response && response.status === 'FAILURE') {
          validCheckListUser(projectInfo, userId, userRoles, otherRoleId, user,props.context);
          return;
        }
      }
      await addOrEditIpsTeamMember(projectInfo, userId, userRoles, otherRoleId, user);
      props.context.setRefreshMemberNotifications(true);
    }
    clearInputs();
    setRefresh(true);
  }

  async function editTeamMember(
    member,
    editRoles,
    phoneNumberChanged,
    otherRoleId
  ) {
    
    

    if (phoneNumberChanged) {
      await updateIpsTeamMemberDetails(projectInfo, member.userId, member);
    }
    if (editRoles.length > 0) {
      // non checklist validation
      if (
        editRoles.filter(
          (t) =>
            t.action === 'A' &&
            (taskRoles.includes(t.roleId) || approverRoles.includes(t.roleId))
        ).length > 0
      ) {
        let response = await getNonCheckListUser(member);
        if (response && response.status === 'FAILURE') {
          validCheckListUser(
            projectInfo,
            member.userId,
            editRoles,
            member.otherRoleId,
            member,
            props.context
          );
          return;
        }
      }
      await addOrEditIpsTeamMember(
        projectInfo,
        member.userId,
        editRoles,
        otherRoleId,
        member
      );
      props.context.setRefreshMemberNotifications(true);
    }
    clearInputs();
    setRefresh(true);
  }

  function clearInputs() {
    setText('');
    setUser({
      userId: '',
      firstName: '',
      lastName: '',
      displayName: '',
      cellNumber: '',
      company: '',
      email: '',
      role: '',
      phoneNumber: '',
    });
    setSelectedRole('0');
    setSelectedOtherRole('0');
    setValidationErrors({});
  }

  //deleting user from team
  async function deleteUser(user) {
    
    

    let response = await deleteIpsUserFromTeam(projectInfo, user.userId);
    if (response && response.status === 'FAILURE') {
      deleteWarning(response);
    } else {
      props.context.setRefreshMemberNotifications(true);
      const filteredTeams = teams.filter((team) => team.userId !== user.userId);
      setTeams(filteredTeams);
      let userIds = [];
      filteredTeams.map((team) => userIds.push(team.userId));
      users.push(user);
    }
    clearInputs();
  }

  const deleteWarning = (response) => {
    let msg = response.statusCode;
    confirmAlert({
      customUI: ({ onClose }) => {
        return <Alert msg={msg} onClose={onClose} />;
      },
    });
  };

  const removeUser = (user) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='react-confirm-alert-body'>
            <h2>Remove Team Members</h2>
            <br />
            <p>Are you sure you want to remove team member?</p>
            <br />
            <div className='btn start-2'>
              <button className='btn btn-primary start-5' onClick={onClose}>
                No
              </button>
              {'  '}
              <button
                className='btn btn-primary start-5'
                onClick={async () => {
                  await deleteUser(user);
                  onClose();
                }}
              >
                Yes
              </button>
            </div>
          </div>
        );
      },
    });
  };

  async function editSelectedUser(team) {
    //console.log('teammember', team);
    const rolesResponse = await getUserRoles();
    const roles = rolesResponse.data;
    const otherRoles = await getOtherRoles();
    confirmAlert({
      closeOnClickOutside: false,
      closeOnEscape: true,
      customUI: ({ onClose }) => {
        return (
          <EditTeamMemberDialog
            editTeamMember={editTeamMember}
            onCancel={onCancel}
            onClose={onClose}
            team={team}
            roles={roles}
            otherRoles={otherRoles}
          />
        );
      },
    });
  }

  async function onCancel(e) {
    clearInputs();
    //const updatedTeams = await getIpsTeamDetails(projectbpid);
    setText('');
    //setTeams(updatedTeams);
    setUser({ userId: '', firstName: '', cellNumber: '', phoneNumber: '' });
    setSelectedRole('0');
    setSelectedOtherRole('0');
    setValidationErrors({});
  }

  function onPhoneTextChange(e) {
    const value = e.target.value.replace(PHONE_REGEX, '');
    setUser((prevState) => {
      const nextState = { ...prevState };
      nextState.phoneNumber = value ? value : '';
      return nextState;
    });
  }

  function onCellPhoneTextChange(e) {
    const value = e.target.value.replace(PHONE_REGEX, '');
    setUser((prevState) => {
      const nextState = { ...prevState };
      nextState.cellNumber = value ? value : '';
      return nextState;
    });
  }

  function teamEmails(teams) {
    let temp = '';
    teams.forEach((item) => {
      temp = temp + item.email + ';';
    });
    return temp;
  }

  function emailCellFormatter(text, record) {
    let webUrl = encodeURIComponent(window.location.href.replace('/team', ''))
    
    let mobileUrl =webUrl.replace(/https|http/gi,'awbs')
    return (
      <a
        href={
          'mailto:' +
          record.email +
          '?subject=' +
          encodeURIComponent(project.stationName) +
          ' Checklist' +
          '&body='+
          webUrl+
          '%0D%0A'+'%0D%0A'+ 
         ' 𝗶𝗣𝗵𝗼𝗻𝗲/𝗶𝗣𝗮𝗱:%20'+mobileUrl
        }
      >
        {text}
      </a>
    );
  }

  function deleteEditCellFormatter(text, record)
  {
    return (
      <>
        <DropdownButton id={`${record.bpid}-team-dropdown`} title='' style={{ width: '100%', position: 'inherit' }}>
          <Dropdown.Item onClick={() => editSelectedUser(record)}>Edit</Dropdown.Item>


          {/*
          old code for grey out
          <Dropdown.Item disabled={record.hasPCRole==='Y' || record.isOnlyApprover==='Y' || record.hasApprovals==='Y'}
            onClick={() => removeUser(record)}>Remove</Dropdown.Item> */}

          {!(record.hasPCRole==='Y' || record.isOnlyApprover==='Y' || record.hasApprovals==='Y')&&<Dropdown.Item
            onClick={() => removeUser(record)}>Remove</Dropdown.Item>}
        </DropdownButton>
        </>
    );
  }

  function roleCellFormatter(text, record) {
    if (record.userRoles.length < 3) {
      return (
        <div>
          {record.userRoles.map((role, index) => (
            <div key={index} >
              {role.hasApprovals === 'Y'
                ? role.roleName + '**'
                : role.isOnlyApproverRole === 'Y'
                ? role.roleName + '*'
                : role.roleId === 24
                ? role.roleName + '(' + record.otherRoleName + ')'
                : role.roleName}
            </div>
          ))}
        </div>
      );
    } else if (record.userRoles.length > 2) {
      let role1 = record.userRoles[0];
      let role2 = record.userRoles[1];
      return (
        <>
          <div>
            {role1.hasApprovals === 'Y'
              ? role1.roleName + '**'
              : role1.isOnlyApproverRole === 'Y'
              ? role1.roleName + '*'
              : role1.roleName}
          </div>
          <div
            style={{ alignItems: 'left', width: 20 }}
            data-tip
            data-for={'toolTip-' + record.userId}
          >
            {role2.hasApprovals === 'Y'
              ? role2.roleName + '**'
              : role2.isOnlyApproverRole === 'Y'
              ? role2.roleName + '*'
              : role2.roleName}{' '}
            {'...'}
          </div>
          <ReactTooltip
            id={'toolTip-' + record.userId}
            place='bottom'
            effect='solid'
            textColor='black'
            backgroundColor='white'
            border={true}
            borderColor='black'
            type='info'
          >
            {record.userRoles.map((role) => (
              <div>
                {role.hasApprovals === 'Y'
                  ? role.roleName + '**'
                  : role.isOnlyApproverRole === 'Y'
                  ? role.roleName + '*'
                  : role.roleId === 24
                  ? role.roleName + '(' + record.otherRoleName + ')'
                  : role.roleName}
              </div>
            ))}
          </ReactTooltip>
        </>
      );
    }
  }
  
  function nameCellFormatter(text, record) {
    return (
      <div>
        {record.firstName} {record.lastName}{' '}
        {record.hasPCRole === 'Y' ? '*' : ''}
      </div>
    );
  }
  
  function composeFiltersName(fieldNameOne,fieldNameTwo) {
    let filters = [...new Set(teams?.map(teamMember => {
      

      if (teamMember[fieldNameOne] && teamMember[fieldNameTwo]) {
        return `${teamMember[fieldNameOne]} ${teamMember[fieldNameTwo]}`
      } else if (!teamMember[fieldNameOne]) {
        return `${teamMember[fieldNameTwo]}`
      } else if (!teamMember[fieldNameTwo]) {
        return `${teamMember[fieldNameOne]}`
      }
      // return `${teamMember[fieldNameOne]} ${teamMember[fieldNameTwo]}`
    }))];
    let filtersSort = filters.map(distinctFilters => ({ label: distinctFilters, value: distinctFilters }));
    filtersSort.sort((a, b) => {
      a = a.text || '';
      b = b.text || '';
      return a.toLowerCase().localeCompare(b.toLowerCase());
    });

    return filtersSort;
  }
  
  
  const columns = [
    {
      dataIndex: 'name',
      key: 'name',
      title: 'NAME',
      render: nameCellFormatter,
      filters:composeFiltersName('firstName','lastName'),
 
  ...SearchAndDropdownComponent(),
      onFilter: (value, record) => {
  
       
  
        return (
          record.firstName?.toLowerCase().includes(value.toLowerCase()) ||
          record.lastName?.toLowerCase().includes(value.toLowerCase()) ||
          
          (record?.firstName &&
            record?.lastName &&
            value === `${record?.firstName} ${record?.lastName}`) ||
          (record?.firstName &&
            !record?.lastName &&
            value === `${record?.firstName}`) ||
          (record?.lastName &&
            !record?.firstName &&
            value === `${record?.lastName}`)
        );
      },
      sorter: (a, b) => {
        
        a = `${a.firstName} ${a.lastName}` || '';
        b = `${b.firstName} ${b.lastName}` || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      }
    },
    {
      dataIndex: 'role',
      key: 'role',
      title: 'ROLE',
      filters: getStationRoleName(teams),
      onFilter: (value, record) => {
           
        let tempResult = record.userRoles.map((everyTaskId) => {
          return everyTaskId.roleId === value;
        });
  
        return tempResult.includes(true);
      },
      sorter: (a, b) => {
        
        a = a.userRoles[0]?.roleName  || '';
        b = b.userRoles[0]?.roleName || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
      render: roleCellFormatter,
      
    },
    {
      dataIndex: 'company',
      key: 'company',
      title: 'COMPANY',
      filters: composeFilters('company',teams),
      onFilter: (value,record)=>commonFilter(value,record,'company'),
      sorter: (a, b) => commonSorter(a,b,'company'),
    },
    {
      dataIndex: 'email',
      key: 'email',
      filters: composeFilters('email',teams),
      onFilter: (value,record)=>commonFilter(value,record,'email'),
      sorter: (a, b) => commonSorter(a,b,'email'),

      showSorterTooltip:false,
      title: (
        <div onClick={(e)=>{e.stopPropagation()}}>
          EMAIL{' '}
          <img
            src={EmailImage}
            style={sectionStyle}
            title='Send Email to Team'
            
            onClick={() => {
              let webUrl = encodeURIComponent(window.location.href.replace('/team', ''))
              
              let mobileUrl =webUrl.replace(/https|http/gi,'awbs')
              
              window.open(
                'mailto:' +
                teamEmails(teams) +
                '?subject=' +
                encodeURIComponent(project.stationName) +
                ' Data Entry Tracker' +
                '&body=' +
                'Please navigate to the Commissioning Checklist to view the project. %0D%0A' +
                webUrl +
                '%0D%0A' + '%0D%0A' + 
                // 'iPhone/iPad Link:%20'+mobileUrl +
                ' 𝗶𝗣𝗵𝗼𝗻𝗲/𝗶𝗣𝗮𝗱:%20'+mobileUrl +
                '%0D%0A'+
                '%0D%0A REMINDER: Please use Google Chrome or Firefox as some features may not work in Internet Explorer/Edge.  You may have to copy and paste into Chrome if IE/Edge is your default browser.'
              )
            }
            }
          />
        </div>
      ),
      render: emailCellFormatter,
     
    },
    {
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
      title: 'PHONE NUMBER',
      filters: composeFilters('phoneNumber',teams),
      onFilter: (value,record)=>commonFilter(value,record,'phoneNumber'),
      sorter: (a, b) => commonSorter(a,b,'phoneNumber'),
    },
    {
      dataIndex: 'cellNumber',
      key: 'cellNumber',
      title: 'CELL PHONE',
      filters: composeFilters('cellNumber',teams),
      onFilter: (value,record)=>commonFilter(value,record,'cellNumber'),
      sorter: (a, b) => commonSorter(a,b,'cellNumber'),
    },
    {
      dataIndex: 'userId',
      key: 'userId',
  
      title: 'ACTIONS',
      render: deleteEditCellFormatter,
     
    },
  ];
  
  let filteredColumns =
    (project.projectStatus !== projectStatusCodeMap['CLOSED'])  && (isIPSDataCreatorOrAdministrator() || isFMPCreatorOrAdministrator()) && project?.allIPSComplFlag !=='Y'?
  columns:
   [
          columns[0],
          columns[1],
          columns[2],
          columns[3],
          columns[4],
          columns[5],
          // columns[6],
        ];

  return (
    <div className='container-fluid' style={{minHeight: "500px"}}>
      {(project.projectStatus !== projectStatusCodeMap['CLOSED']) && (isIPSDataCreatorOrAdministrator() || isFMPCreatorOrAdministrator()) &&
        project?.allIPSComplFlag !=='Y'&&
       <>
          <Row>
            <Tooltip placement='top' title={tooltext}>
              <i
                className='fa fa-info-circle fa-2x'
                style={{ marginRight: 8, paddingTop: 4 }}
              />
            </Tooltip>
            <Col xs={24} md={{ span: 12, offset: 6, }}
              id='project-search'
              style={{ paddingRight: 0 }}
            >
              <Input
                autoComplete='off'
                type='text'
                value={text}
                onChange={updateText}
                id='searchUser'
                allowClear
                placeholder='Search First Name OR Last Name OR User ID'
                prefix={
                  <SearchOutlined
                    id='search-icon'
                    style={{ marginRight: 8, padding: 0 }}
                  />
                }
              />
              <span className='stationNameDropdown'>
                {suggestions && suggestions.length > 0 && renderSuggestions()}
              </span>
            </Col>
            <Col xs={12} md={{ span: 6, offset: 6, }}>
              <button
                type='button'
                className='btn btn-primary btn-block'
                style={{ marginBottom: '14px', width: '100px' }}
                onClick={onTextChanged}
              >
                Search
              </button>
            </Col>
          </Row>
      <Row>
            <div className='col-12'>
              <div className='row align-items-center'>
                <div className='col-12 col-sm-4 col-lg-2'>
                  <div className='autocompletetext-team'>
                    <Input
                      className='text-control'
                      id='company'
                      value={user.company}
                      placeholder='Company'
                      autoComplete='off'
                      disabled={true}
                    />
                  </div>
                </div>
                <div className='col-12 col-sm-4 col-lg-2'>
                  <select
                    className='drop-down-B'
                    onChange={handleChange}
                    value={selectedRole}
                  >
                    <option id='role' key='default' value={0}>
                      Please Select Role
                    </option>
                    {roles.map((role, index) => (
                      <option id='role' key={role.roleId} value={role.roleId}>
                        {' '}
                        {role.roleName}
                      </option>
                    ))}
                  </select>
                  {validationErrors.role ? (
                    <div className='error-message'>* Please Select a Role</div>
                  ) : (
                    <div />
                  )}
                </div>

                {selectedRole === '24' ? (
                  <div className='col-12 col-sm-4 col-lg-2'>
                    <select
                      onChange={handleOtherRoleChange}
                      value={selectedOtherRole}
                      className='drop-down-B'
                    >
                      <option id='otherrole' key='default' value={0}>
                        Select Other Role
                      </option>
                      {otherRoles.map((role, index) => (
                        <option
                          id='otherrole'
                          key={role.otherRoleId}
                          value={role.otherRoleId}
                        >
                          {role.otherRoleName}
                        </option>
                      ))}
                    </select>
                  </div>
                ) : (
                  <div />
                )}

                <div className='col-12 col-sm-4 col-lg-2'>
                  <div className='autocompletetext-team'>
                    <Input
                      className='text-control'
                      id='email'
                      value={user.email}
                      placeholder='Email'
                      disabled={true}
                    />
                  </div>
                </div>
                <div className='col-12 col-sm-4 col-lg-2'>
                  <div className='autocompletetext-team'>
                    <NumberFormat
                      className='text-control'
                      id='phoneNumber'
                      autoComplete='off'
                      type='text'
                      value={user.phoneNumber}
                      onChange={onPhoneTextChange}
                      placeholder='Phone'
                      format='###-###-####'
                      mask=''
                      disabled={false}
                    />
                  </div>
                </div>
                <div className='col-12 col-sm-4 col-lg-2'>
                  <div className='autocompletetext-team'>
                    <NumberFormat
                      className='text-control'
                      id='cellPhone'
                      autoComplete='off'
                      type='text'
                      value={user.cellNumber}
                      onChange={onCellPhoneTextChange}
                      placeholder='Cell Phone'
                      format='###-###-####'
                      mask=''
                      disabled={false}
                    />
                  </div>
                </div>
                <div className='col-12 col-sm-4 col-lg-2'>
                  <button
                    type='button'
                    className='btn btn-primary btn-block'
                    style={{ marginBottom: '14px' }}
                    onClick={addUserToTeam}
                  >
                    ADD MEMBER
                  </button>
                </div>
              </div>
            </div>
      </Row>
      </>
}
      <Row>
        <div>
          <i
            className='fa fa-info-circle'
            style={{ color: 'red', paddingRight: '3px' }}
            aria-hidden='true'
          ></i>
          <i>
            <b>
              Note: Team Members identified on an Exception Form cannot be
              removed from the project. <br />
              (*=Exception Form Primary Contact or only Approver in that Role,
              and **=Exception Approver already responded to a Form)
            </b>
          </i>
        </div>
      </Row>
      <Row>
        <div className='table-responsive antd-table-custom-css'
        
        style={{ overflow: 'hidden', 
        
          
        
        }}
        
        >
         
          <Table
            
            
            columns={filteredColumns}
            bordered
            
           loading={refresh}
            
            dataSource={teams}
            locale={{ emptyText: (refresh?(<Empty description={(<h6>Loading</h6>)} />):<Empty description={(<h6>No Team Members Found</h6>)} />) }} 
            pagination={{ showSizeChanger: false, pageSize: 10 }}
          />
        </div>
      </Row>
    </div>
  );
}

export default withRouter(IPSTeam);